(function () {
    document.querySelectorAll('.jormi-tabs').forEach(function (block) {
        const blockId = block.dataset.blockId;
        if (!blockId) return;

        const buttons = block.querySelectorAll('.jormi-tabs__tab-button');
        const panels  = block.querySelectorAll('.jormi-tabs__panel');

        buttons.forEach(function (button) {
            button.addEventListener('click', function () {
                const targetId = button.dataset.tabTarget;

                // Deactivate all buttons
                buttons.forEach(function (btn) {
                    btn.classList.remove('jormi-tabs__tab-button--active');
                    btn.setAttribute('aria-selected', 'false');
                });

                // Hide all panels
                panels.forEach(function (panel) {
                    panel.classList.add('hidden');
                });

                // Activate clicked button
                button.classList.add('jormi-tabs__tab-button--active');
                button.setAttribute('aria-selected', 'true');

                // Show target panel
                const target = document.getElementById(targetId);
                if (target) {
                    target.classList.remove('hidden');
                }
            });
        });
    });
})();